import styled, { css } from 'styled-components';
import store from '@/store';
import { SMARTPHONE } from '@/constants';

export const ModalWrapper = styled.div`
  width: min-content;
  height: ${props => (props.$height ? props.$height : 'auto')};
  top: 50%;
  left: 50%;
  outline: none;
  position: absolute;
  transform: translate(-50%, -50%);
  background-color: white;
  display: grid;
  grid-template-rows: 64px 1fr ${props => props.$includeFooter ? 'min-content' : ''};
  font-family: Lato;

  ${props => {
    if (!props.$excludeMobileStyle) {
      const { core: { targetDevice } } = store.getState();

      switch (targetDevice) {
        case SMARTPHONE: {
          return css`
            width: 100%;
            height: 100%;
            transform: none;
            top: 0;
            left: 0;
          `;
        }
        default: {
          return null;
        }
      }
    }
  }}
`;

export const ModalHeader = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 50px 1fr 50px;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.35);
  background-color: #f2f2f2;
`;

export const ModalFooter = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  align-items: center;
  justify-content: stretch;
  box-shadow: 0 -1px 3px 0 rgba(0, 0, 0, 0.35);
  background-color: #f2f2f2;
  padding: 17px;
  
  font-size: 18px;
  color: #030303;
`;

export const IconButton = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const Label = styled.div`
  font-size: 18px;
  letter-spacing: -0.43px;
  text-align: center;
  color: #030303;
`;

export const MaterialIconStyle = {
    color: '#9aa0b0',
    width: '28px',
    height: '28px'
};
